import React from 'react'
import ReactDOM from 'react-dom'
import ReactGA from 'react-ga'

import * as serviceWorker from './serviceWorker'

import Firebase, { FirebaseContext } from './components/Firebase'

import App from './components/App'

import CssBaseline from '@material-ui/core/CssBaseline'
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core'
import { purple, red } from '@material-ui/core/colors'

import { SHOW_LOGS } from './constants/logs'

const theme = createMuiTheme({
  palette: {
    primary: purple,
    secondary: red,
    type: 'light'
  },
  spacing: {
    unit: 8
  },
  typography: {
    useNextVariants: true
  }
})

// Initialize Google Analytics
ReactGA.initialize('UA-134116506-1')

if (SHOW_LOGS) console.log('theme:', theme);

ReactDOM.render(
  <MuiThemeProvider theme={theme}>
    <FirebaseContext.Provider value={new Firebase()}>
      <CssBaseline />
      <App />
    </FirebaseContext.Provider>
  </MuiThemeProvider>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()
